(() => {
  if (window.slHeaderReady) return;
  window.slHeaderReady = true;

  const desktop = window.matchMedia('(min-width: 990px)');
  const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const DROPDOWN = '[data-sl-nav-dropdown]';

  const closeMenu = (menu) => {
    if (!menu || !menu.open) return;
    menu.removeAttribute('open');
    const summary = menu.querySelector('summary');
    if (summary) summary.focus();
  };

  const closeDropdowns = (except) => {
    document.querySelectorAll(`${DROPDOWN}[open]`).forEach((dropdown) => {
      if (dropdown !== except) dropdown.removeAttribute('open');
    });
  };

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const dropdown = document.querySelector(`${DROPDOWN}[open]`);
    if (dropdown) {
      closeMenu(dropdown);
      return;
    }
    closeMenu(document.querySelector('[data-sl-header-menu][open]'));
  });

  document.addEventListener('click', (event) => {
    const dropdown = event.target.closest(DROPDOWN);
    closeDropdowns(dropdown);
    if (
      dropdown &&
      dropdown.open &&
      hover.matches &&
      event.detail > 0 &&
      event.target.closest('summary')
    ) {
      event.preventDefault();
      return;
    }
    if (dropdown && event.target.closest('.sl-header__panel a')) dropdown.removeAttribute('open');

    const menu = document.querySelector('[data-sl-header-menu][open]');
    if (!menu) return;
    if (event.target.closest('.sl-header__drawer a')) {
      menu.removeAttribute('open');
      return;
    }
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });

  document.addEventListener('focusin', (event) => {
    const dropdown = event.target.closest ? event.target.closest(DROPDOWN) : null;
    closeDropdowns(dropdown);
  });

  let leaveTimer;

  document.addEventListener('pointerover', (event) => {
    if (!hover.matches || event.pointerType !== 'mouse') return;
    const item = event.target.closest('.sl-header__item');
    const dropdown = item ? item.querySelector(DROPDOWN) : null;
    if (!dropdown) return;
    clearTimeout(leaveTimer);
    closeDropdowns(dropdown);
    dropdown.setAttribute('open', '');
  });

  document.addEventListener('pointerout', (event) => {
    if (!hover.matches || event.pointerType !== 'mouse') return;
    const item = event.target.closest('.sl-header__item');
    const dropdown = item ? item.querySelector(DROPDOWN) : null;
    if (!dropdown || item.contains(event.relatedTarget)) return;
    clearTimeout(leaveTimer);
    leaveTimer = setTimeout(() => dropdown.removeAttribute('open'), 160);
  });

  document.addEventListener('toggle', (event) => {
    if (!event.target.matches || !event.target.matches('[data-sl-header-menu]')) return;
    document.documentElement.classList.toggle('sl-menu-open', event.target.open);
  }, true);

  desktop.addEventListener('change', (event) => {
    if (event.matches) {
      const menu = document.querySelector('[data-sl-header-menu][open]');
      if (menu) menu.removeAttribute('open');
    } else {
      closeDropdowns();
    }
  });

  const header = document.querySelector('[data-sl-header]');
  if (!header) return;
  const root = document.documentElement;
  const bar = document.querySelector('.sl-reviews-bar-section');

  let stack = 0;
  const measure = () => {
    const headerHeight = header.offsetHeight;
    stack = headerHeight + (bar ? bar.offsetHeight : 0);
    root.style.setProperty('--sl-header-live', `${headerHeight}px`);
    root.style.setProperty('--sl-top-stack', `${stack}px`);
  };
  measure();
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(measure);
    observer.observe(header);
    if (bar) observer.observe(bar);
  }

  if (!header.hasAttribute('data-sl-header-hide')) return;

  const setHidden = (hidden) => root.classList.toggle('sl-header-hidden', hidden);
  const mustShow = () =>
    root.classList.contains('sl-menu-open') ||
    document.querySelector(`${DROPDOWN}[open]`) ||
    header.contains(document.activeElement) ||
    (bar && bar.contains(document.activeElement));

  let lastY = Math.max(window.scrollY, 0);
  let ticking = false;

  const update = () => {
    ticking = false;
    const y = Math.max(window.scrollY, 0);
    const delta = y - lastY;
    if (y <= stack || mustShow()) {
      setHidden(false);
    } else if (Math.abs(delta) < 6) {
      return;
    } else {
      setHidden(delta > 0);
    }
    lastY = y;
  };

  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }, { passive: true });

  header.addEventListener('focusin', () => setHidden(false));
  if (bar) bar.addEventListener('focusin', () => setHidden(false));

  requestAnimationFrame(() => root.classList.add('sl-header-ready'));
})();
